import classNames from "classnames";
import { forwardRef } from "react";

export interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingMessage?: string;
}

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ isLoading, loadingMessage, children, disabled, className, ...buttonProps }, ref) => {
    return (
      <button
        ref={ref}
        disabled={disabled || isLoading}
        {...buttonProps}
        className={classNames(className, { loading: isLoading })}
      >
        {isLoading ? (
          <>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> {loadingMessage}
          </>
        ) : (
          children
        )}
      </button>
    );
  }
);

LoadingButton.displayName = "LoadingButton";
